import React from "react";
import { MessageCircle } from "lucide-react";

const WhatsAppButton = ({ className = "" }) => (
  <a
    href="https://wa.me/971585862273?text=Hello%20ACRE%2C%20I%27d%20like%20to%20discuss%20UAE%20property%20opportunities."
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with ACRE on WhatsApp"
    data-testid="whatsapp-float-button"
    className={`hidden sm:flex fixed bottom-6 right-6 z-50 items-center gap-2.5 bg-[#0E382B] border border-[rgba(197,168,128,0.35)] text-[#F4F3EF] pl-4 pr-5 py-3.5 rounded-full shadow-[0_12px_40px_-8px_rgba(14,56,43,0.8)] hover:shadow-[0_12px_44px_-6px_rgba(197,168,128,0.4)] hover:border-[#C5A880] transition-all duration-300 ${className}`}
  >
    <MessageCircle size={20} className="text-[#E6CA65]" />
    <span className="text-xs font-semibold tracking-wide hidden sm:inline">Speak to an Adviser</span>
  </a>
);

export const WHATSAPP_URL =
  "https://wa.me/971585862273?text=Hello%20ACRE%2C%20I%27d%20like%20to%20discuss%20UAE%20property%20opportunities.";

export default WhatsAppButton;
